import script from "./AlbumStructureNode.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumStructureNode.vue?vue&type=script&setup=true&lang=js"

import "./AlbumStructureNode.vue?vue&type=style&index=0&id=84b76036&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b76036"]])

export default __exports__